import React, { useState, useEffect, Fragment, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import clsx from "clsx";
import { Button, TextField } from "@packages/ui";
import SnackBar from "../../layouts/SnackBar";
import {
  Box,
  Link,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
  Typography,
  List,
  ListItem,
  IconButton,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  makeStyles,
  Grid,
} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Alert from "@material-ui/lab/Alert";
import _, { set } from "lodash";
import moment from "moment";

import * as checkinActions from "src/actions/checkinActions";
import { REGIONS, COUNTRY } from "../../utils/constants";
import getCountryFromURL from "src/utils/getCountryFromUrl";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import getDemoFromUrl from "src/utils/getDemoFromUrl";
import { isMobile } from "react-device-detect";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { apiURI } from "../../env";
import * as constants from "../../utils/constants";

const useStyles = makeStyles((theme) => ({
  accordion: {
    marginLeft: 10,
    marginRight: 10,
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: "none",
    "&.Mui-expanded": {
      margin: 10,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100vw",
    height: "100vh",
  },
  headerFont: {
    color: "black",
  },
  summary: {
    backgroundColor: "#ffffff00",
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
  groupLabel: {
    backgroundColor: "blue",
  },
  removeContainer: {
    ".pac-container:after": {
      content: "none !important",
    },
  },
  wrapIcon: {
    verticalAlign: "middle",
    display: "block",
  },
  root: {
    textAlign: "center",
    color: "red",
  },
  container: {
    position: "relative",
  },
  suggestionsContainerOpen: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  suggestion: {
    display: "block",
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
  divider: {
    height: theme.spacing(2),
  },
  typography: {
    color: "red",
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: `${theme.palette.primary.white}`,
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
      border: `1px solid ${theme.palette.primary.darkergrey}`,
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.primary.ocean,
    },
  },
  checkedIcon: {
    backgroundColor: `${theme.palette.primary.main}`,
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.primary.ocean,
    },
  },
}));

function StyledCheckbox(props) {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ "aria-label": "decorative checkbox" }}
      {...props}
    />
  );
}

const CheckinForm = (props) => {
  const dispatch = useDispatch();
  // const [bookingNumber, setBookingNumber] = useState("B04NP9");
  // const [bookingNumber, setBookingNumber] = useState("B04Q4H");
  // const [lastName, setSurname] = useState("TRASMONTE");
  // const [licno, setLicno] = useState("DU1234567890");
  const [carsPlusExpiryDate, setCarsPlusExpiryDate] = useState(null);
  const [OCRExpiryDate, setOCRExpiryDate] = useState(null);
  const [expiryMatch, setExpiryMatch] = useState(true);
  const [newLoading, setNewLoading] = useState(false); // solve the issue of multiple requests loading
  // const [hasCustomer, setHasCustomer] = useState(false);
  const [valve, setValve] = useState(false); // for controlling the retrieval of existing customer
  const [requireLicNo, setRequireLicNo] = useState(false);
  const [dialogBox, setDialogBoxOpen] = useState(false);
  const [isNoResNo, setIsNoResNo] = useState(false);
  const [atLeastTwoFieldsError, setAtLeastTwoFieldsError] = useState("");
  const [isInternationalDL, setIsInternationalDL] = useState(false);
  const [noExpiryChecked, setNoExpiryChecked] = useState(false);
  const [idvDlExpired, setIdvDlExpired] = useState(false); //check if dl in OCRlabs has expired (even idv is completed_pass)
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const paramBookingNumber = urlParams.get("bookingNumber") ? urlParams.get("bookingNumber") : "";
  const paramLastName = urlParams.get("lastName") ? urlParams.get("lastName") : "";
  const checkin = useSelector((state) => state.checkin);
  const brandLocations = useSelector((state) => state.checkin.brandLocations);
  const idvStatus = useSelector((state) => state.checkin.idVerification);
  const brand = getBrandFromUrl();
  const country = getCountryFromURL();
  const isDemo = getDemoFromUrl();
  const location = useLocation();

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);

  let icon_Url_Step1;
  let icon_Url_Step2;
  let icon_Url_Step3;
  let icon_Url_Step4;
  switch (brand) {
    case "Ace":
      icon_Url_Step1 = constants.ACE_STEPS_ICON_1;
      icon_Url_Step2 = constants.ACE_STEPS_ICON_2;
      icon_Url_Step3 = constants.ACE_STEPS_ICON_3;
      icon_Url_Step4 = constants.ACE_STEPS_ICON_4;
      break;
    case "Dollar":
      icon_Url_Step1 = constants.DOLLAR_STEPS_ICON_1;
      icon_Url_Step2 = constants.DOLLAR_STEPS_ICON_2;
      icon_Url_Step3 = constants.DOLLAR_STEPS_ICON_3;
      icon_Url_Step4 = constants.DOLLAR_STEPS_ICON_4;
      break;
    case "Thrifty":
      icon_Url_Step1 = constants.THRIFTY_STEPS_ICON_1;
      icon_Url_Step2 = constants.THRIFTY_STEPS_ICON_2;
      icon_Url_Step3 = constants.THRIFTY_STEPS_ICON_3;
      icon_Url_Step4 = constants.THRIFTY_STEPS_ICON_4;
      break;
    default:
      icon_Url_Step1 = constants.HERTZ_STEPS_ICON_1;
      icon_Url_Step2 = constants.HERTZ_STEPS_ICON_2;
      icon_Url_Step3 = constants.HERTZ_STEPS_ICON_3;
      icon_Url_Step4 = constants.HERTZ_STEPS_ICON_4;
      break;
  }

  let path;
  if (brand == "Dollar" && !isDemo) {
    path = checkin.isAdditionalDriver
      ? {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/additional-driver-checkin/steps",
      }
      : {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/checkin/steps",
      };
  } else if (brand == "Thrifty" && !isDemo) {
    path = checkin.isAdditionalDriver
      ? {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/additional-driver-checkin/steps",
      }
      : {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/checkin/steps",
      };
  } else if (brand == "Hertz" && !isDemo) {
    path = checkin.isAdditionalDriver
      ? {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/additional-driver-checkin/steps",
      }
      : {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/checkin/steps",
      };
  } else if (brand == "Ace" && !isDemo) {
    path = checkin.isAdditionalDriver
      ? {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/additional-driver-checkin/steps",
      }
      : {
        url_privacy:
          "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
        url_touchless:
          "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
        next: "/checkin/steps",
      };
  } else if (brand == "Dollar" && isDemo) {
    path = {
      url_privacy:
        "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
      url_touchless:
        "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
      next: "/checkin-demo/steps",
    };
  } else if (brand == "Thrifty" && isDemo) {
    path = {
      url_privacy:
        "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
      url_touchless:
        "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
      next: "/checkin-demo/steps",
    };
  } else if (brand == "Hertz" && isDemo) {
    path = {
      url_privacy:
        "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
      url_touchless:
        "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
      next: "/checkin-demo/steps",
    };
  } else if (brand == "Ace" && isDemo) {
    path = {
      url_privacy:
        "https://privacy-central.eu.securiti.ai/notice-embed/800cf249-f2db-4887-a07b-8ae21891e35b",
      url_touchless:
        "https://images.hertz.com/pdfs/Hertz_Touchless_Privacy_Disclosure_Consent_and_Release-English.pdf",
      next: "/checkin-demo/steps",
    };
  }

  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [values, setValues] = useState(getCountryFromURL() == "AU" ? COUNTRY[0] : COUNTRY[1]);
  const [inputValue, setInputValue] = useState("");
  const [custRequireIDV, setCustRequireIDV] = useState(true);
  const isHCCWorkflow = useSelector((state) => state.checkin.resType === "HX");
  const [DNR, setDNR] = useState(false);
  // const requireVerify = checkin.verifyCC && checkin.verifyID;
  const requireVerify = checkin.verifyID;
  const viewedPrivacy = [
    "INPROGRESS",
    "AUTO_COMPLETED",
    "COMPLETED",
    "VOID_FAILED",
    "VOC_FAILED",
    "CHECKIN_FORM",
  ].includes(checkin.checkinStatus);
  const checkinCompleted = checkin.checkinStatus == "COMPLETED";
  const formatChars = {
    n: "[0-3]",
    m: "[0-9]",
    e: "[0-1]",
    d: "[0-9]",
    z: "[1-2]",
    y: "[0-9]",
  };
  const dateFormatter = (date, srcFormat, destFormat) => {
    return moment(date, srcFormat).format(destFormat);
  };

  const randomNumber = useMemo(() => {
    return Math.random();
  }, [checkin.resNo]);

  useEffect(() => {
    const today = moment().startOf("day");
    const OCRValid =
      checkin.customer.IdVerification?.Status == "COMPLETED_PASS" &&
      moment(OCRExpiryDate, "YYYY-MM-DD").isAfter(today);

    let skipDVS = false;

    const note = checkin?.reservation?.ReservationMainNote;
    if (typeof note === "string" && (note.includes("CIW") || note.includes("CIP"))) {
      skipDVS = true;
    }

    // if idvDlExpired, use pixel tracking to set idverified=Expired in the backend:
    if (moment(OCRExpiryDate, "YYYY-MM-DD").isBefore(today)) {
      setIdvDlExpired(true);
    }

    const carsPlusExpired =
      Date.parse(checkin.customer.LatestCustomer?.DrivingLicence?.ExpiryDate) < Date.now();
    // console.log("test:", OCRValid, OCRExpiryDate, moment(OCRExpiryDate, "YYYY-MM-DD").isAfter(today));

    setCustRequireIDV(carsPlusExpired || (!OCRValid && !skipDVS) || !expiryMatch);

    // console.log("test", !carsPlusExpired && OCRValid && expiryMatch, carsPlusExpired, OCRValid, expiryMatch)
    console.log("!carsPlusExpired: ", !carsPlusExpired);
    console.log("OCRValid: ", OCRValid);
    console.log("expiryMatch: ", expiryMatch);
    if (!carsPlusExpired && OCRValid && expiryMatch) {
      dispatch(checkinActions.idVerificationSkipped({}));
    } else if (skipDVS) {
      dispatch(checkinActions.idVerificationSkipped({}));
    } else if (!checkin.verifyID) {
      dispatch(checkinActions.idVerificationSkipped({}));
    } else {
      dispatch(checkinActions.idVerificationRequired({}));
    }
  }, [checkin.customer, checkin.reservation, expiryMatch, OCRExpiryDate]);

  useEffect(() => {
    const homePhone = checkin.reservation?.Renter?.Address?.HomeTelephoneNumber
      ? checkin.reservation.Renter.Address.HomeTelephoneNumber
      : checkin.customer?.LatestCustomer?.Address?.HomeTelephoneNumber || "";

    const cellPhone = checkin.reservation?.Renter?.Address?.CellTelephoneNumber
      ? checkin.reservation.Renter.Address.CellTelephoneNumber
      : checkin.customer?.LatestCustomer?.Address?.CellTelephoneNumber || "";

    const email = checkin.reservation?.Renter?.Address?.Email
      ? checkin.reservation.Renter.Address.Email
      : checkin.customer?.LatestCustomer?.Address?.Email || "";

    // Clean up '+' signs and assign defaults
    const cleanedHomePhone = homePhone.replace(/\+/g, "");
    const cleanedCellPhone = cellPhone.replace(/\+/g, "");

    // Always set values, even if empty
    setValue("phone", cleanedHomePhone);
    setValue("alternatePhone", cleanedCellPhone);
    setValue("email", email);
  }, [checkin.reservation, checkin.customer]);

  useEffect(() => {
    setDNR(checkin?.customer?.DNR);
    // setHasCustomer(!_.isEmpty(checkin.customer?.LatestCustomer));
    const cpExpiryDate = checkin.customer?.LatestCustomer?.DrivingLicence?.ExpiryDate || null;
    setCarsPlusExpiryDate(cpExpiryDate);
    if (cpExpiryDate) {
      const formattedDate = dateFormatter(cpExpiryDate, "YYYY-MM-DD", "DD/MM/YYYY");
      setValue("dlExpiryDate", formattedDate);
    }
  }, [checkin.customer]);

  useEffect(() => {
    if (
      checkin.auth.token != "" &&
      checkin.auth.success &&
      idvStatus.TransactionId &&
      !idvStatus.DateOfExpiry &&
      idvStatus.fetchFailed === undefined &&
      !idvStatus.fetchingIdvStatus
    ) {
      setNewLoading(true);
      dispatch(
        checkinActions.requestIdVerificationStatus({
          token: checkin.auth.token,
          transactionId: idvStatus.TransactionId,
        })
      );
    }
    if ((idvStatus.DateOfExpiry || idvStatus.fetchFailed) && !idvStatus.fetchingIdvStatus) {
      setNewLoading(false);
    }
  }, [
    idvStatus.TransactionId,
    idvStatus.DateOfExpiry,
    idvStatus.fetchFailed,
    idvStatus.fetchingIdvStatus,
  ]);

  useEffect(() => {
    const cpExpiryDate = checkin.customer?.LatestCustomer?.DrivingLicence?.ExpiryDate || null;
    const idvExpiryDate = idvStatus.DateOfExpiry || null; // it's dl expiry date in id verfication transac
    setCarsPlusExpiryDate(cpExpiryDate);
    setOCRExpiryDate(idvExpiryDate);
    if (cpExpiryDate && idvExpiryDate) {
      setExpiryMatch(
        moment(cpExpiryDate, "YYYY-MM-DD").isSame(moment(idvExpiryDate, "YYYY-MM-DD"))
      );
    }
  }, [idvStatus?.DateOfExpiry, checkin.customer?.LatestCustomer?.DrivingLicence?.ExpiryDate]);

  useEffect(() => {
    if (checkin.auth.token != "" && checkin.auth.success && _.isEmpty(checkin.resNo)) {
      dispatch(checkinActions.checkin({ token: checkin.auth.token }));
      dispatch(checkinActions.getOcrLabsOutage({ token: checkin.auth.token }));
    }
  }, [checkin.auth.token]);

  useEffect(() => {
    let param_brand = undefined;
    switch (brand) {
      case "Dollar":
        param_brand = "ZR";
        break;
      case "Thrifty":
        param_brand = "ZT";
        break;
      case "Hertz":
        param_brand = "ZE";
        break;
      default:
        param_brand = "ZE";
        break;
    }
    dispatch(checkinActions.setCheckinDemo({ isDemo: isDemo }));
    dispatch(checkinActions.getBrandLocations({ brand: param_brand, country: country }));
  }, []);

  useEffect(() => {
    if (DNR == true) {
      setDialogBoxOpen(true);
    } else if (checkin.auth.token == "" && _.has(checkin, "resNo")) {
      window.location.replace(isDemo ? "/checkin/login" : "/checkin/login");
      setDialogBoxOpen(false);
    } else if (DNR == false && checkin.auth.token != "" && _.isEmpty(checkin.reservation)) {
      dispatch(
        checkinActions.retrieveReservation({ resNo: checkin.resNo, token: checkin.auth.token })
      );
    }
  }, [DNR]);

  useEffect(() => {
    if (
      checkin.auth.success &&
      moment().isBefore(moment.unix(checkin.auth.expires)) &&
      DNR == false &&
      !_.isUndefined(checkin.reservation.Renter)
    ) {
      if (isDemo) {
        dispatch(checkinActions.setRequireReVerifyCC({ requireReVerifyCC: true }));
        dispatch(checkinActions.setRequireReVerifyID({ requireReVerifyID: true }));
        dispatch(checkinActions.resetVerifyStatus());
        navigate(`/checkin-demo/privacy/${brand.toLowerCase()}`, { replace: true });
      } else if (requireVerify) {
        if (!isMobile && custRequireIDV) {
          //forbid idv on desktop
        } else {
          if (valve) {
            if (!viewedPrivacy) {
              // navigate(`/${isDemo ? "checkin-demo" : "checkin"}/privacy/${brand.toLowerCase()}`, {
              //   replace: true,
              // });
              navigate(`/${isDemo ? "checkin-demo" : "checkin"}/verify`, { replace: true });
            } else if (checkinCompleted) {
              navigate(`/${isDemo ? "checkin-demo" : "checkin"}/checkin-summary`, {
                replace: true,
              });
            } else {
              navigate(`/${isDemo ? "checkin-demo" : "checkin"}/verify`, { replace: true });
            }
          }
        }
      } else {
        if (valve) {
          if (checkinCompleted) {
            navigate(`/${isDemo ? "checkin-demo" : "checkin"}/checkin-summary`, { replace: true });
          } else {
            navigate(`/${isDemo ? "checkin-demo" : "checkin"}/checkin-form`, { replace: true });
          }
        }
      }
    } else if (moment() < moment(checkin.auth.expires)) {
      // can't online checkin because it's past the day to pick it up
      // TODO: dispatch error that you can't online checkin past pick up date
    } else if (
      checkin.success &&
      moment() < moment(checkin.auth.expires) &&
      _.isEmpty(checkin.reservation)
    ) {
      // error: reservation returned empty
      // TODO: post error that something has gone wrong with online checkin
    }
  }, [checkin.reservation, checkin.customer, valve]);

  useEffect(() => {
    if (
      checkin.auth.token != "" &&
      checkin.auth.success &&
      checkin.resNo &&
      _.isEmpty(checkin.reservation)
    ) {
      setRequireLicNo(true);
    }
  }, [checkin.resNo]);

  const noResFieldsToValidate = ["lastName", "goldNo", "pickupDate", "pickupLoc"];

  const atLeastTwoFieldsSet = (fields, value) => {
    const fieldsFilled = fields.filter(
      (field) => value[field] !== undefined && value[field] !== null && value[field] !== ""
    );
    const isPass = fieldsFilled.length >= 2;
    if (!isPass) {
      setAtLeastTwoFieldsError("Please provide at least two values to proceed");
    } else {
      setAtLeastTwoFieldsError("");
    }
    return isPass;
  };

  const validationSchema = !requireLicNo
    ? isNoResNo
      ? Yup.object()
        .shape({
          lastName: Yup.string().max(25, "Last name should not be more than 25 characters"),
          goldNo: Yup.string(),
          pickupDate: Yup.string(),
          pickupLoc: Yup.string(),
        })
        .test(function (value) {
          return atLeastTwoFieldsSet(noResFieldsToValidate, value);
        })
      : Yup.object().shape({
        bookingNumber: Yup.string()
          .required("Required")
          .test("bookingNumber", "Booking Number is invalid", function (bkNumber) {
            const bookingLength = bkNumber.trim().length;
            const islength =
              bookingLength == 6
                ? true
                : bookingLength == 9
                  ? true
                  : bookingLength == 10
                    ? true
                    : bookingLength == 11
                      ? true
                      : false;
            return islength;
          }),
        lastName: Yup.string()
          .required("Required")
          .max(25, "Last name should not be more than 25 characters"),
        travelCountry: Yup.object().required("Required"),
      })
    // : hasCustomer ? Yup.object().shape({
    : openInfoDialog ? Yup.object().shape({
        licNo: Yup.string()
          .required("Required")
          .min(4, "Driving Licence must be more than 3 characters")
          .matches(/^[a-zA-Z0-9-]*$/, "Licence Number should only use Letters, Numbers, Hyphen")
          .max(20, "Driving Licence should not have more than 20 characters")
          .test("match", "Your Licence Number should match with the reservation", function (match) {
            return (
              match.toUpperCase() == _.get(checkin, "LicenceNumber", null) ||
              _.get(checkin, "LicenceNumber", null) == null
            );
          }),
        dlExpiryDate: Yup.string().matches(
          /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
          {
            message: "Please Enter Date in dd/mm/yyyy Format",
            excludeEmptyString: true,
          }
        ),
        phone: Yup.string()
          .required("Required")
          .max(15, "Contact Number must be less then 15 numbers ")
          .matches(
            /^[1-9]{1}[0-9]{7,11}$/,
            "Please Enter mobile number in countrycode followed by mobile number format"
          ),
        alternatePhone: Yup.string().test(
          "contact Number match",
          "Please use different alternate phone number",
          function (value) {
            return this.parent.phone != value;
          }
        ),
      })
    : Yup.object().shape({
        licNo: Yup.string()
          .required("Required")
          .min(4, "Driving Licence must be more than 3 characters")
          .matches(/^[a-zA-Z0-9-]*$/, "Licence Number should only use Letters, Numbers, Hyphen")
          .max(20, "Driving Licence should not have more than 20 characters")
          .test("match", "Your Licence Number should match with the reservation", function (match) {
            return (
              match.toUpperCase() == _.get(checkin, "LicenceNumber", null) ||
              _.get(checkin, "LicenceNumber", null) == null
            );
          }),
        dlExpiryDate: Yup.string().matches(
          /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/,
          {
            message: "Please Enter Date in dd/mm/yyyy Format",
            excludeEmptyString: true,
          }
        ),
      });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      bookingNumber: props.resNo ? props.resNo : "",
      goldNo: "",
      pickupDate: "",
      pickupLoc: "",
      lastName: paramLastName,
      travelCountry: values,
      licNo: "",
      regionOfIssue: "",
      email: "",
      phone: "",
      alternatePhone: "",
      dlExpiryDate: "",
    },
  });

  const getFutureDate = () => {
    const futureDate = new Date();
    futureDate.setFullYear(futureDate.getFullYear() + 2);
    return moment(futureDate).format("DD/MM/YYYY");
  };

  const handleCheckboxChange = (e, onChange) => {
    const isChecked = e.target.checked;
    const newValue = isChecked
      ? getFutureDate()
      : moment(carsPlusExpiryDate, "YYYY-MM-DD").format("DD/MM/YYYY") || "";
    setNoExpiryChecked(isChecked);
    setExpiryMatch(true);
    onChange(newValue);
  };

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const Countries = _.sortBy(REGIONS, ["label"]);

  const options =
    Countries.map((option) => {
      const countryFirstLetter = option.country[0].toLocaleUpperCase();
      return {
        countryFirstLetter: countryFirstLetter,
        ...option,
      };
    }) || [];

  const handleClose = () => {
    dispatch(checkinActions.logout());
    // Token empty set false
    setDialogBoxOpen(false);
    setRequireLicNo(false);
  };

  const checkBookingNumber = (bookingNumber) => {
    if (props.resNo.slice(-1) === "-") {
      const uppercase = (bookingNumber + "-").toUpperCase().trim();
      if (uppercase === props.resNo.toUpperCase()) {
        return props.resNo.toUpperCase();
      }
    }
    return bookingNumber;
  };

  const onSubmit = async (data) => {
    if (checkin.loading || newLoading) {
      console.log("onSubmit loading on");
      return;
    }

    const bookingNumber = checkBookingNumber(data.bookingNumber.trim().toUpperCase());
    const lastName = data.lastName.trim();
    const country = data.travelCountry.value;
    const licNo = data.licNo.trim().toUpperCase();
    const pickupDate = data.pickupDate.trim();
    const pickupLoc = data.pickupLoc.trim();
    const goldNo = data.goldNo.trim();
    const alternatePhone = data.alternatePhone.trim();
    const dlExpiryDate = data.dlExpiryDate.trim();
    const formattedPickupDate = moment(pickupDate, "DD/MM/YYYY").format("YYYY-MM-DD");
    const isValidDate = formattedPickupDate != "Invalid date";
    if (!requireLicNo) {
      if (isNoResNo) {
        await dispatch(
          checkinActions.checkinAuth({
            lastName,
            pickupDate: isValidDate ? formattedPickupDate : "",
            pickupLoc,
            goldNo,
            country,
          })
        );
      } else {
        await dispatch(
          checkinActions.checkinAuth({
            bookingNumber,
            lastName,
            country,
          })
        );
      }
    } else {
      // if (hasCustomer) {
      if (openInfoDialog) {
        await dispatch(checkinActions.setRequireReVerifyID({ requireReVerifyID: custRequireIDV }));
        if (!expiryMatch) {
          dispatch(checkinActions.resetIDVerifyStatus());
        }
        const region = REGIONS.find((r) => r.label === data.regionOfIssue);
        const regionValue = region ? region.value : null;
        const newContact = {
          email: data.email,
          phoneNumber: data.phone,
          alternatePhone: alternatePhone,
          regionOfIssue: regionValue
        };
        console.log("newContact: ", newContact);
        await dispatch(checkinActions.updateCustomerContact(newContact));
        setValve(true);
      } else {
        const licCountry = data.regionOfIssue;
        await dispatch(
          checkinActions.searchCustomer({
            licNo: licNo,
            country: licCountry,
            resNo: checkin.resNo,
            token: checkin.auth.token,
            isAdditionalDriver: checkin.isAdditionalDriver,
          })
        );
        setOpenInfoDialog(true);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {!requireLicNo ? (
          <div>
            {isNoResNo ? (
              <>
                <Box style={{ fontSize: "0.8rem", display: "flex", justifyContent: "end" }}>
                  <Link
                    component={"button"}
                    underline="always"
                    style={{
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      reset();
                      setAtLeastTwoFieldsError("");
                      setIsNoResNo(false);
                    }}
                  >
                    {`Return to main page.`}
                  </Link>
                </Box>
                <Controller
                  control={control}
                  name="lastName"
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      fullWidth
                      label="Last Name"
                      value={value}
                      onChange={onChange}
                      error={errors.lastName ? true : false}
                      helperText={errors.lastName ? errors.lastName.message : null}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="goldNo"
                  render={({ field: { onChange, value, name, ref } }) => (
                    <TextField
                      fullWidth
                      label="Loyalty Number"
                      id="goldNo"
                      value={value}
                      onChange={onChange}
                      error={errors.goldNo ? true : false}
                      helperText={errors.goldNo ? errors.goldNo.message : null}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="pickupDate"
                  render={({ field: { onChange, value, name, ref } }) => (
                    <InputMask
                      mask="99/99/9999"
                      value={value}
                      onChange={onChange}
                      maskChar=" "
                      label="Pickup Date (dd/mm/yyyy)"
                    >
                      {() => (
                        <TextField
                          fullWidth
                          id="pickupDate"
                          name="pickupDate"
                          placeholder={"Pickup Date (dd/mm/yyyy)"}
                          label={"Pickup Date (dd/mm/yyyy)"}
                          style={{ marginTop: 15, padding: 0 }}
                          error={errors.pickupDate ? true : false}
                          helperText={errors.pickupDate ? errors.pickupDate.message : null}
                          inputProps={{ inputMode: "numeric" }}
                        />
                      )}
                    </InputMask>
                  )}
                />
                <Controller
                  control={control}
                  name="pickupLoc"
                  render={({ field: { onChange, value, name, ref } }) => (
                    <Autocomplete
                      label="pickupLoc"
                      id="pickupLoc"
                      name="pickupLoc"
                      disableClearable
                      options={brandLocations}
                      getOptionLabel={(option) => option?.locationName || ""}
                      renderOption={(option) => option.locationName}
                      getOptionSelected={(option, value) =>
                        option.locationName == value.locationName
                      }
                      renderInput={(params) => (
                        <TextField
                          inputProps={{ inputMode: "string" }}
                          {...params}
                          fullWidth
                          value={value}
                          label="Pickup Location"
                          placeholder={"Pickup Location"}
                          error={errors.pickupDate ? true : false}
                          helperText={errors.pickupDate ? errors.pickupDate.message : null}
                        />
                      )}
                      onChange={(e, data) => onChange(data.locationName)}
                    />
                  )}
                />
              </>
            ) : (
              <>
                {/* Trigger Button */}
                <Box style={{ textAlign: "right" }}>
                  <IconButton
                    onClick={handleOpenDialog}
                    style={{
                      fontSize: "0.9rem",
                      color: "#a0a0a0",
                    }}
                  >
                    Online Check-in&nbsp;
                    <InfoIcon
                      style={{
                        fontSize: "1.3rem",
                        color: "black",
                      }}
                    />
                  </IconButton>
                </Box>
                <Dialog open={open} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                  <DialogContent dividers style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    <Grid container direction="column" spacing={3}>
                      <Grid item>
                        <Box
                          style={{
                            padding: 16,
                            borderRadius: 8,
                            border: "1px solid rgba(0,0,0,0.08)",
                            background: "linear-gradient(180deg, #fff, #fbfbfb)",
                            height: "100%",
                          }}
                        >
                          <Box style={{ marginTop: 8 }}>
                            <Typography variant="h4" style={{ textAlign: "center", color: "#263238", marginBottom: 10, marginTop: 10 }} gutterBottom>
                              <strong>Save Time with Online Check-In</strong>
                            </Typography>

                            <Box>
                              <Typography variant="body1" style={{ color: "#546E7A", padding: "10px 8px", borderBottom: "1px solid rgba(0,0,0,0.04)" }}>
                                Complete your details online before you arrive and make your pick-up faster.
                              </Typography>
                              <Typography variant="body1" style={{ color: "#546E7A", padding: "10px 8px" }}>
                                Customers who qualify for <strong>express service</strong> will receive an <strong>SMS with details</strong> once check-in is complete.
                              </Typography>
                            </Box>
                          </Box>

                          <Box style={{ borderTop: "1px solid rgba(0,0,0,0.06)", marginTop: 8, paddingTop: 12 }}>
                            <Typography variant="h4" style={{ textAlign: "center", color: "#263238", marginBottom: 10, marginTop: 10 }} gutterBottom>
                              <strong>Before you start:</strong>
                            </Typography>

                            <Box>
                              <Typography variant="body1" style={{ color: "#546E7A", padding: "10px 8px", borderBottom: "1px solid rgba(0,0,0,0.04)" }}>
                                Have your <strong>driver’s licence</strong> ready.
                              </Typography>
                              <Typography variant="body1" style={{ color: "#546E7A", padding: "10px 8px" }}>
                                Use a <strong>mobile phone</strong> for the process.
                              </Typography>
                            </Box>
                          </Box>

                          <Box style={{ borderTop: "1px solid rgba(0,0,0,0.06)", marginTop: 12, paddingTop: 12 }}>
                            <Typography variant="h4" style={{ textAlign: "center", color: "#263238", marginBottom: 10, marginTop: 10 }} gutterBottom>
                              <strong>Here’s what you’ll do:</strong>
                            </Typography>

                            <Box>
                              <Typography variant="body1" style={{ color: "#546E7A", padding: "10px 8px", borderBottom: "1px solid rgba(0,0,0,0.04)" }}>
                                Enter your <strong>booking number</strong>.
                              </Typography>
                              <Typography variant="body1" style={{ color: "#546E7A", padding: "10px 8px", borderBottom: "1px solid rgba(0,0,0,0.04)" }}>
                                Submit a <strong>photo of your driver’s licence</strong>.
                              </Typography>
                              <Typography variant="body1" style={{ color: "#546E7A", padding: "10px 8px", borderBottom: "1px solid rgba(0,0,0,0.04)" }}>
                                Take a <strong>short selfie video</strong> to verify your identity (if applicable).
                              </Typography>
                              <Typography variant="body1" style={{ color: "#546E7A", padding: "10px 8px" }}>
                                For returning customers, your ID verification stays valid for <strong>2 years</strong>, unless your licence expires before then.
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </DialogContent>
                </Dialog>
                <Box style={{ fontSize: "0.8rem", display: "flex", justifyContent: "end" }}>
                  <Typography
                    style={{ color: "#a0a0a0", fontSize: "0.9rem" }}
                  >{`Don't have your booking number?`}</Typography>
                  <Typography>&nbsp;</Typography>
                  <Link
                    underline="always"
                    component={"button"}
                    style={{
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      reset();
                      setAtLeastTwoFieldsError("");
                      setIsNoResNo(true);
                    }}
                  >
                    {` Search here.`}
                  </Link>
                </Box>
                <Controller
                  control={control}
                  name="bookingNumber"
                  render={({ field: { onChange, value, name, ref } }) => (
                    <TextField
                      fullWidth
                      label="Booking Number"
                      id="bookingNumber"
                      value={value}
                      onChange={onChange}
                      error={errors.bookingNumber ? true : false}
                      helperText={errors.bookingNumber ? errors.bookingNumber.message : null}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="lastName"
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      fullWidth
                      label="Last Name"
                      value={value}
                      onChange={onChange}
                      error={errors.lastName ? true : false}
                      helperText={errors.lastName ? errors.lastName.message : null}
                    />
                  )}
                />
              </>
            )}
            {isNoResNo && atLeastTwoFieldsError != "" && (
              <Typography variant="body2" color="error">
                {atLeastTwoFieldsError}
              </Typography>
            )}

            <Controller
              name="travelCountry"
              control={control}
              render={({ field: { onChange, value } }) => {
                const countryOption =
                  getCountryFromURL() === "NZ"
                    ? { value: "NZ", label: "New Zealand" }
                    : { value: "AU", label: "Australia" };

                return (
                  <TextField
                    fullWidth
                    error={errors.travelCountry ? true : false}
                    helperText={errors.travelCountry ? "Required" : null}
                    value={countryOption.label}
                    label="Country of Travel"
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                );
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "0.9rem",
              }}
            >
              <List
                style={{
                  marginTop: "10px",
                  marginBottom: "5px",
                }}
                subheader={
                  <Typography
                    variant="subtitle1"
                    style={{ color: "#a0a0a0", textAlign: "middle", fontSize: "0.9rem" }}
                  >
                    To Continue, you must read and agree to:
                  </Typography>
                }
              >
                <ListItem disableGutters style={{ paddingLeft: 0 }}>
                  <Link href={path.url_privacy} target="_blank" style={{ marginLeft: 0 }}>
                    i. Privacy Policy
                  </Link>
                </ListItem>
                <ListItem disableGutters style={{ paddingLeft: 0 }}>
                  <Link href={path.url_touchless} target="_blank" style={{ marginLeft: 0 }}>
                    ii. Touchless Privacy Disclosure, Consent and Release
                  </Link>
                </ListItem>
              </List>
            </div>
          </div>
        ) : (
          <Fragment>
            <Controller
              control={control}
              name="licNo"
              render={({ field: { onChange, value } }) => (
                <TextField
                  fullWidth
                  label="Drivers Licence Number"
                  value={value}
                  onChange={onChange}
                  error={errors.licNo ? true : false}
                  helperText={errors.licNo ? errors.licNo.message : null}
                />
              )}
            />
            <Controller
              control={control}
              name="regionOfIssue"
              render={({ field: { onChange, value } }) => (
                <Autocomplete
                  label="regionOfIssue"
                  disableClearable
                  options={options
                    .sort((a, b) => -b.countryFirstLetter.localeCompare(a.countryFirstLetter))
                    .sort()}
                  groupBy={(option) => option.country}
                  getOptionLabel={(option) => option.label}
                  defaultValue={options.find((element) => element.label == value) || null}
                  renderOption={(option) => option.label}
                  getOptionSelected={(option) => option.country}
                  renderInput={(params) => (
                    <TextField
                      inputProps={{
                        autoComplete: "new-password",
                      }}
                      {...params}
                      fullWidth
                      required
                      label="State/Country Of Issue"
                      error={errors.regionOfIssue ? true : false}
                      helperText={errors.regionOfIssue ? errors.regionOfIssue.message : null}
                    />
                  )}
                  onChange={(e, data) => {
                    onChange(data.country);
                    setIsInternationalDL(!["AUSTRALIA", "NEW ZEALAND"].includes(data.country));
                  }}
                />
              )}
            />
            {/* {hasCustomer &&  */}
            {openInfoDialog && (
              <Fragment>
                {/* <Controller
                  control={control}
                  name="email"
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      fullWidth
                      label="Email"
                      required
                      value={value}
                      onChange={onChange}
                      error={errors.email ? true : false}
                      helperText={errors.email ? errors.email.message : null}
                    />
                  )}
                /> */}
                <Controller
                  control={control}
                  name="email"
                  rules={{
                    required: "Email is required",
                    pattern: {
                      // A pragmatic regex that covers most valid cases without being overkill
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  }}
                  render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <TextField
                      fullWidth
                      label="Email"
                      required
                      value={value ?? ""}
                      onChange={onChange}
                      error={!!error}
                      helperText={error?.message || null}
                      type="email"            // HTML5 validation hint (optional)
                      inputMode="email"       // Mobile keyboard hint
                      autoComplete="email"
                    />
                  )}
                />
                <Grid item xs={12} md={4}>
                  <Controller
                    control={control}
                    name="phone"
                    render={({ field: { onChange, value } }) => (
                      <PhoneInput
                        // name="phone"
                        // id="phone"
                        inputProps={{ required: true }}
                        value={value}
                        preferredCountries={["au", "nz"]}
                        country={"au"}
                        style={{ marginBottom: "4px", marginTop: "4px" }}
                        inputStyle={{ width: "100%", height: "100%", color: "#263238" }}
                        buttonStyle={{
                          paddingTop: "18px",
                        }}
                        specialLabel={
                          <span style={{ color: "rgb(84, 110, 122)" }}>Mobile Phone *</span>
                        }
                        error={errors.phone ? true : false}
                        helperText={errors.phone ? errors.phone.message : null}
                        onChange={onChange}
                      />
                    )}
                  />
                  {errors.phone && (
                    <p
                      style={{
                        color: "#f44336",
                        fontSize: "0.75rem",
                        marginLeft: "14px",
                        marginRight: "14px",
                        // marginBottom: '12px'
                      }}
                    >
                      {errors.phone.message}
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} md={4}>
                  <Controller
                    control={control}
                    name="alternatePhone"
                    render={({ field: { onChange, value } }) => (
                      <PhoneInput
                        // name="alternatePhone"
                        // id="alternatePhone"
                        value={value}
                        preferredCountries={["au", "nz"]}
                        country={"au"}
                        style={{ marginBottom: "4px", marginTop: "12px" }}
                        inputStyle={{ width: "100%", height: "100%", color: "#263238" }}
                        buttonStyle={{
                          paddingTop: "18px",
                        }}
                        specialLabel={
                          <span style={{ color: "rgb(84, 110, 122)" }}>
                            Alternate Phone
                          </span>
                        }
                        error={errors.alternatePhone ? true : false}
                        helperText={
                          errors.alternatePhone
                            ? errors.alternatePhone.message
                            : null
                        }
                        onChange={onChange}
                      />
                    )}
                  />
                  {errors.alternatePhone && (
                    <p
                      style={{
                        color: "#f44336",
                        fontSize: "0.75rem",
                        marginLeft: "14px",
                        marginRight: "14px",
                        marginBottom: "8px",
                      }}
                    >
                      {errors.alternatePhone.message}
                    </p>
                  )}
                </Grid>

                {carsPlusExpiryDate && (
                  <Controller
                    name="dlExpiryDate"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <>
                        {isInternationalDL && (
                          <FormControlLabel
                            onChange={(e) => handleCheckboxChange(e, onChange)}
                            control={<StyledCheckbox />}
                            label={
                              <span style={{ fontSize: 12 }}>
                                My Driver&apos;s License Does Not Have Expiry
                              </span>
                            }
                            style={{ marginLeft: "0px" }}
                          />
                        )}
                        {!noExpiryChecked && (
                          <InputMask
                            alwaysShowMask={false}
                            formatChars={formatChars}
                            mask="dd/mm/yyyy"
                            maskChar=" "
                            disabled={false}
                            onChange={(e) => {
                              setExpiryMatch(
                                moment(e.target.value, "DD/MM/YYYY").isSame(
                                  moment(idvStatus.DateOfExpiry, "YYYY-MM-DD")
                                )
                              );
                              onChange(e.target.value);
                            }}
                            value={value}
                          >
                            {(inputProps) => (
                              <TextField
                                id="expiry-text-field"
                                placeholder="Driver License Expiry Date"
                                label="Driver License Expiry Date (dd/mm/yyyy)"
                                fullWidth
                                required
                                value={inputProps.value}
                                error={errors.dlExpiryDate ? true : false}
                                helperText={
                                  errors.dlExpiryDate ? errors.dlExpiryDate.message : null
                                }
                              />
                            )}
                          </InputMask>
                        )}
                      </>
                    )}
                  />
                )}
              </Fragment>
            )}
          </Fragment>
        )}

        <Box style={{ marginTop: 15 }}>
          <Button
            fullWidth
            disabled={
              !isMobile && requireVerify &&
              ((!_.isEmpty(checkin.customer.LatestCustomer) && custRequireIDV && !newLoading) ||
                checkin.customer.LatestCustomer === null)
            }
            loading={checkin.loading || newLoading}
            loadingIndicator="Loading..."
            type="submit"
            title={requireLicNo ? openInfoDialog ? "Continue" : "Confirm" : "I Agree"}
          />
        </Box>

        {!isMobile &&
          requireVerify &&
          ((!_.isEmpty(checkin.customer.LatestCustomer) && custRequireIDV && !newLoading) ||
            checkin.customer.LatestCustomer === null) && (
            <Alert style={{ marginTop: 15 }} severity="error">
              Sorry, you must use a mobile device to continue checkin!
            </Alert>
          )}
      </form>

      <SnackBar />

      <Dialog
        open={dialogBox}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {checkin.country == "AU" && brand == "Thrifty"
              ? "Unfortunately your profile has been restricted, please contact our Australian Customer Service Team on 1300 110 196. Please quote your driver’s licence number and reservation number."
              : checkin.country == "AU" && brand == "Dollar"
                ? "Unfortunately your profile has been restricted, please contact our Australian Customer Service Team on 1800 501 967. Please quote your driver’s licence number and reservation number."
                : checkin.country == "AU"
                  ? "Unfortunately your profile has been restricted, please contact our Australian Customer Service Team on 1800 55 00 78. Please quote your driver’s licence number and reservation number."
                  : "Unfortunately your profile has been restricted, please contact our New Zealand Customer Service Team on 0800 921 460. Please quote your driver’s licence number and reservation number."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button fullWidth onClick={handleClose} loading={checkin.loading} title={"Continue!"} />
        </DialogActions>
      </Dialog>
      {idvDlExpired && (
        <img
          src={`${apiURI}/pixel/${window.location.pathname.replace(/\//g, "_")}.png?b=${checkin.resNo
            }&a=${"idv_dl_expired"}&country=${country}&c=${randomNumber}&brand=${brand}&t=${checkin.isAdditionalDriver ? "additional_driver" : "primary_driver"
            }`}
          style={{ display: "none" }}
        />
      )}
    </div>
  );
};

export default CheckinForm;
